import React from 'react';
import { Link } from 'react-router-dom';
import { LegalFooter } from '../legal/LegalLinks';

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-mono-base flex flex-col" data-testid="paid-coming-soon">
      <header className="border-b border-mono-line">
        <div className="max-w-5xl mx-auto px-4 md:px-8 h-14 flex items-center">
          <span className="text-white font-heading text-xs md:text-sm font-bold uppercase tracking-[0.25em]">
            Coach Rands Method
          </span>
        </div>
      </header>
      <main className="flex-1 flex items-center">
        <div className="max-w-5xl w-full mx-auto px-4 md:px-8 py-16">
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-none mb-4" data-testid="paid-coming-soon-title">
            Coming soon
          </h1>
          <p className="text-mono-mute font-body text-base mb-8">
            The full coaching programme is not open yet. The free pull-up tracker is.
          </p>
          <Link
            to="/free"
            className="inline-block border border-crimson text-crimson hover:bg-crimson hover:text-white font-heading font-bold text-sm uppercase tracking-wider rounded-none px-6 py-3 transition-colors"
            data-testid="paid-coming-soon-free-link"
          >
            Use the free tracker →
          </Link>
        </div>
      </main>
      <LegalFooter />
    </div>
  );
}
